<template>
  <div>
    <div v-if="logueado">
      <div class="headeryfooter text-center">
        <h2 style="color: white">{{ Seleccionado.apellido_y_nombre }}</h2>
      </div>
      <div class="primary pa-2">
        <v-icon left dark>mdi-clipboard-text-outline</v-icon>
        <span style="color: white; font-weight: bold">MIS PRACTICAS</span>
      </div>
      <lista
        nofiltrar
        vertodas
        sololistar
        :items="ListaPorAfiliado"
        v-model="practicaselected"
      ></lista>
      <!-- <practica
            readonly
            autogestion
            v-if="practicaselected"
            :solic="practicaselected"
            @guardado="guardado()"
          ></practica> -->
      <!-- <v-tab-item>
          <altaPractica
            @practicaGuardada="traerPorAfiliado(Seleccionado.id_afiliado)"
            class="pt-3"
            :id_afiliado="Seleccionado.id_afiliado"
            :id_plan="Seleccionado.id_plan"
            :IdImagenes="IdImagenes"
          ></altaPractica>
        </v-tab-item> -->
    </div>
  </div>
</template>

<script>
// import lista from "@/components/Practica/ListaPorBeneficiario";
import lista from "@/components/Practica/Lista";
import listaGrupo from "@/components/Beneficiarios/ListaAfiliados";

import { mapActions, mapState } from "vuex";
import API from "../../../lib/API";
export default {
  components: {
    lista,
    listaGrupo,
  },
  data() {
    return {
      tab: 0,
      IdImagenes: 0,
      practicaselected: undefined,
      logueotitular: false,
    };
  },
  computed: {
    ...mapState("autogestion", ["Usuario"]),
    ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
    ...mapState("autorizaciones", ["ListaPorAfiliado"]),
    logueado() {
      return this.Seleccionado !== undefined && this.Seleccionado !== null;
    },
  },
  methods: {
    ...mapActions("autorizaciones", ["traerPorAfiliado"]),
    ...mapActions("beneficiarios", ["select"]),
    ...mapActions("autogestion", ["inicializar"]),
  },
  watch: {
    Seleccionado() {
      if (this.Seleccionado) {
        this.traerPorAfiliado(this.Seleccionado.id_afiliado);
      }
    },
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario) {
        this.$router.push({ name: "Autogestion" });
      }
    }
    if (this.Usuario && this.Seleccionado == undefined) {
      let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId);
      this.select(ben);
    }
    if (this.Seleccionado) {
      this.traerPorAfiliado(this.Seleccionado.id_afiliado);
    }
  },
};
</script>

<style></style>
